<template>
  <div>
    <el-row style="display: flex;margin-bottom: 10px;">

      <el-col>
        <el-button v-if="addUserVisitorClass" @click="$form('addUserVisitorClass')" size='small' type="primary"
          style="float:right" icon='el-icon-circle-plus'>添加官方拜访分类
        </el-button>
      </el-col>
    </el-row>
    <div>
      <myform :viewobj='{
        addUserVisitorClass: ["新增官方拜访分类", "el-icon-circle-plus"],
        updateUserVisitorClass: ["修改官方拜访分类", "el-icon-edit-outline"],
        $succeed$: getUserVisitorClassList
      }' @confirm='myform' @close='$form("addUserVisitorClass", "reset")'>
        <template v-slot:uvcIcon='{ Myformdata }'>
          <myupload v-event.fileUpload='`
                      return (Myformdata.uvcIcon+"").startsWith("http") 
                        || ( (C = (await C.MyUpload()).file) ? Myformdata.uvcIcon = C : false )
                    `' @change='Myformdata.uvcIcon = ($file$ = arguments[0]).url'
            @remove='window.sleep(150, v => Myformdata.uvcIcon = "")' type='image' :limit='1' :params='{ file: "$file$" }'
            :filelist='Myformdata.uvcIcon
                ? ({ name: Myformdata.name, url: Myformdata.uvcIcon })
                : false
              ' :style="{ height: Myformdata.uvcIcon && $form('updateUserVisitorClass', 'ifshow') ? '250px' : '' }">
          </myupload>
        </template>

        <hide slot='uvcId' />
      </myform>
      <mytable :tableColums='tableColums_getUserVisitorClassList' api='getUserVisitorClassList'
        xupdateapi='updateOpportunityBusinessCheckImage' :height="H - 165">
        <icol slot='uvcIcon' :showtooltip='false' img='uvcIcon' />
      </mytable>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      theProjectId: 0,
      value: '',
      form: {
        projectId: '',

      },
      tableColums_getUserVisitorClassList: {
        $selection: false,

        // oiType: '限制字段key',

        uvcName: '拜访名称',
        uvcIcon: '背景图',
        uvcOrder: '排序',

        $operation: [
          '操作', 200,
          this.updateUserVisitorClass && `@text: 编辑#success
             @click: $form("updateUserVisitorClass",$this.row = $row)
            `,
          this.deleteUserVisitorClass && `@text: 删除#danger
             @click: _confirm('确定要删除该填写项约束吗?')
                     .trigger('deleteUserVisitorClass',{uvcId:$row.uvcId})
                     .trigger('getUserVisitorClassList')
            `,
        ],
      }
    }
  },
  methods: {
    myform(submit, Myformdata) {
      this.$trigger("fileUpload").trigger(res => res && submit());
    },

  },
  created() {
    this.getUserVisitorClassList();
  },
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/bussiness/OfficialVisit.vue